import { createSelector } from 'reselect';
import { get as _get } from 'lodash';

import { selectFirestore, selectListPendingFactory } from 'services/selectors';

const selectVenuesState = state => state.venues;

export const selectPending = createSelector(selectVenuesState, venues => venues.pending);

export const selectListPending = selectListPendingFactory(selectPending);

export const selectVenuesForMap = createSelector(selectFirestore, firestore =>
    _get(firestore, 'ordered.venues', [])
        .map(venue => {
            const location = _get(venue, 'location', null);
            if (location) {
                return {
                    ...venue,
                    lat: location._lat,
                    lng: location._long,
                };
            }
            return null;
        })
        .filter(Boolean),
);
